import { RecordStore } from '@deqo/foundation';
import { WorkspaceLiteData } from '../../api/ApiTypes';
import { AccountPlanLiteData, AccountTrialLiteData, HomeData } from '../../api/endpoints/me';

const accountTemplate = {
    id: null as string,
    podId: null as string,
    label: 'None',
    imageUrl: null as string,
    createdAt: new Date(1970),
    plan: { name: 'none', label: 'None', features: {}, quantity: 0, } as AccountPlanLiteData,
    settings: {} as Record<string, any>,
    trial: null as AccountTrialLiteData,
    metadata: {} as Record<string, any>,
    workspaces: [] as WorkspaceLiteData[],
    legacy: false,
};

const swizzle = ({ account, workspaces, legacy }: HomeData) => ({
    ...account,
    workspaces,
    legacy,
});

export class AccountModel extends RecordStore(accountTemplate) {

    public get active() {
        return this.id !== null && this.id !== undefined;
    }

    public static from(data: HomeData) {
        const model = new AccountModel();
        model.setState(swizzle(data));
        return model;
    }

    public static async load(provider: () => Promise<HomeData>) {
        const initial = await provider();
        const model = new AccountModel();
        model.setState(swizzle(initial));
        return [
            model,
            async () => {
                const latest = await provider();
                model.updateState(swizzle(latest));
            }
        ] as const;
    }
}
